import { Language } from '../types';
import { languageOptions, LS_LANGUAGE_KEY } from '../config';

export const getCurrentLanguageObject = (): Language | undefined => {
  const languageFromLS = localStorage.getItem(LS_LANGUAGE_KEY);
  if (!languageFromLS) return undefined;
  if (!(languageFromLS in languageOptions)) return undefined;
  return languageOptions[languageFromLS as keyof typeof languageOptions];
};
